import { useId, useEffect, useRef } from "react";
import { FDWAntragsteller } from "../../../restfd2/fdw_result.ts";
import { useQuestionizerStore } from "../types/state.ts";
import Toggle from "./toggle.tsx";

// export default function InputAntragsteller (props: {id: number, label: string}){
//   const antragsteller = useQuestionizerStore((state) => state.antragsteller);
//   const setAntragsteller = useQuestionizerStore((state) => state.setAntragsteller);
//   const setValidation = useQuestionizerStore((state) => state.setValidation);
  
//   return <div>
//     <label>{props.label}</label>
//     <input type="text" value={""} onChange={()=>{
//       setValidation(props.id, {message:"", valid: true});
//     }}/>
//   </div>
// }

export default function InputAntragstellerSelect (props: {id: number, label: string, onBlur?: ()=>void}){
  const id = useId()

  const antragsteller = useQuestionizerStore((state) => state.antragsteller);
  const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
  const setantragsteller_detail = useQuestionizerStore((state) => state.setantragsteller_detail);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const config = useQuestionizerStore((state) => state.config);
  const baseurl = config?.baseurl! || "";
  const toggleRef = useRef<HTMLDivElement | null>(null);
  const label = useQuestionizerStore((state) => state.translation.labels['input-antragsteller-select']);

const sameSet = (a: number[], b: number[]) =>
  a.length === b.length && a.every(v => b.includes(v));
 
const GROUP_KOMMUNEN = [7, 14, 15, 16, 20];
const GROUP_OEFFENTLICH = [5, 11, 6, 21, 4, 17, 22];
const GROUP_UNTERNEHMEN = [16, 20, 1, 2, 3, 13, 18, 12, 19, 10];
 
const TOGGLES_KOMMUNEN = [
  { icon: "client-icons/universal/kommunen.svg", icon_active: "client-icons/active/kommunen.svg", value: 7 },
  { icon: "client-icons/universal/kommunale-gebietskoerperschaften.svg", icon_active: "client-icons/active/kommunale-gebietskoerperschaften.svg", value: 14 },
  { icon: "client-icons/universal/kommunale-zweckverbaende.svg", icon_active: "client-icons/active/kommunale-zweckverbaende.svg", value: 15 },
  { icon: "client-icons/universal/kommunale-unternehmen.svg", icon_active: "client-icons/active/kommunale-unternehmen.svg", value: 16 },
  { icon: "client-icons/universal/stadtwerke.svg", icon_active: "client-icons/active/stadtwerke.svg", value: 20 }
];

const TOGGLES_OEFFENTLICH = [
  { icon: "client-icons/universal/vereine.svg", icon_active: "client-icons/active/vereine.svg", value: 5 },
  { icon: "client-icons/universal/verbaende.svg", icon_active: "client-icons/active/verbaende.svg", value: 11 },
  { icon: "client-icons/universal/stiftungen.svg", icon_active: "client-icons/active/stiftungen.svg", value: 6 },
  { icon: "client-icons/universal/bildungseinrichtungen.svg", icon_active: "client-icons/active/bildungseinrichtungen.svg", value: 21 },
  { icon: "client-icons/universal/kirchen.svg", icon_active: "client-icons/active/kirchen.svg", value: 4 },
  { icon: "client-icons/universal/juristische-personen-des-oeffentlichen-rechts.svg", icon_active: "client-icons/active/juristische-personen-des-oeffentlichen-rechts.svg", value: 17 },
  { icon: "client-icons/universal/sonstige-koerperschaften-des-oeffentlichen-rechts.svg", icon_active: "client-icons/active/sonstige-koerperschaften-des-oeffentlichen-rechts.svg", value: 22 }
];

const TOGGLES_UNTERNEHMEN = [
  { icon: "client-icons/universal/kommunale-unternehmen.svg", icon_active: "client-icons/active/kommunale-unternehmen.svg", value: 16 },
  { icon: "client-icons/universal/stadtwerke.svg", icon_active: "client-icons/active/stadtwerke.svg", value: 20 },
  { icon: "client-icons/universal/kleine-und-mittelstaendige_unternehmen-kmu.svg", icon_active: "client-icons/active/kleine-und-mittelstaendige_unternehmen-kmu.svg", value: 1 },
  { icon: "client-icons/universal/grosse-unternehmen-der-gewerblichen-wirtschaft.svg", icon_active: "client-icons/active/grosse-unternehmen-der-gewerblichen-wirtschaft.svg", value: 2 },
  { icon: "client-icons/universal/unternehmen-der-wohnwirtschaft.svg", icon_active: "client-icons/active/unternehmen-der-wohnwirtschaft.svg", value: 3 },
  { icon: "client-icons/universal/wohnungsgenossenschaften.svg", icon_active: "client-icons/active/wohnungsgenossenschaften.svg", value: 13 },
  { icon: "client-icons/universal/projektgesellschaften.svg", icon_active: "client-icons/active/projektgesellschaften.svg", value: 18 },
  { icon: "client-icons/universal/freiberuflich-taetige.svg", icon_active: "client-icons/active/freiberuflich-taetige.svg", value: 12 },
  { icon: "client-icons/universal/agrarbetriebe.svg", icon_active: "client-icons/active/agrarbetriebe.svg", value: 19 },
  { icon: "client-icons/universal/juristische-personen.svg", icon_active: "client-icons/active/juristische-personen.svg", value: 10 }

];

let toggleOptions = [];

if (sameSet(antragsteller, GROUP_KOMMUNEN)) {
  toggleOptions = TOGGLES_KOMMUNEN;
} else if (sameSet(antragsteller, GROUP_OEFFENTLICH)) {
  toggleOptions = TOGGLES_OEFFENTLICH;
} else if (sameSet(antragsteller, GROUP_UNTERNEHMEN)) {
  toggleOptions = TOGGLES_UNTERNEHMEN;
}

useEffect(() => {
  if (toggleOptions.length > 0 && toggleRef.current) {
    toggleRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
}, [toggleOptions.length]);

 if (antragsteller === undefined || antragsteller.length < 2){return <div></div>}
  return <div role="group" aria-expanded="true" tabindex="0" class="group group-9999 section section-1 section--group">
  <div role="heading" aria-level="2" class="section__header"><h2 class="section__title">{label}</h2></div>
  <div ref={toggleRef} class="section__inputs section__inputs--grid">
		{toggleOptions.map((opt) => (
		  <Toggle
			key={opt.value}
			id={props.id.toString()}
			label={props.label}
			icon={baseurl + opt.icon}
			icon_active={baseurl + opt.icon_active}
			value={antragsteller_detail === opt.value}
			onBlur={props.onBlur}
			onChange={() => {
			  if (antragsteller_detail !== opt.value) {
				setantragsteller_detail(opt.value);
				updateValidation();
			  }
			}}
		  />
		))}
	 </div>
  </div>
  
}
